import {type} from 'arktype'

export const Credential = type({
  email: 'string | null',
  gh_login_id: 'string | null',
  first_name: 'string | null',
  last_name: 'string | null',
  brand: 'string | null',
  ud_id: 'string | null',
  created_date: 'string | null',
  disable_password: 'boolean',
  disabled: 'boolean',
  disable_date: 'string | null',
  last_login_date: 'string | null',
  email_verification_date: 'string | null',
  first_cross_over_at: 'string | null',
  silo_id: 'string | null',
})

export type Credential = typeof Credential.infer

export const Claim = type({
  ud_id: 'string | null',
  claim_id: 'string | null',
  claim: 'string | null',
  claim_type: 'string | null',
})
export type Claim = typeof Claim.infer

export const SessionHandle = type({
  access_token: 'string | null',
  token_type: 'string | null',
  expire_in: 'number',
  refresh_token: 'string | null',
  refresh_expire_in: 'number',
  token_created: 'string | null',
  refresh_token_created: 'string | null',
  grubhub_token: 'string | null',
  token_created_time: 'number',
  refresh_token_created_time: 'number',
  token_expire_time: 'number',
  refresh_token_expire_time: 'number',
  tracking_id: 'string | null',
  last_login_time: 'string | null',
  login_session_id: 'string | null',
  disabled: 'boolean',
  refresh_token_remaining_secs: 'number',
  token_remaining_secs: 'number',
  idle_timeout_mins: 'string | null',
})

export const AuthProps = type({
  credential: Credential,
  claims: Claim.array(),
  session_handle: SessionHandle,
})
